/**
 * La sesión de la pestaña (plan §1.8: sigue en sessionStorage, una identidad por pestaña). Mismas claves que la SPA vieja
 * para que una recarga o el paso entre la SPA vieja y un documento /sistema conserven la sesión:
 * lib/api.ts:196 (token), lib/auth.tsx:30 (usuario), :216 (sucursales) y :231 (sucursal elegida).
 * No importa lib/auth.tsx: es el proveedor de React de la SPA vieja.
 */
import { clearAccessToken } from '../../lib/api';
export const CLAVE_TOKEN = 'kapi:access_token';
export const CLAVE_USUARIO = 'kapi:user';
export const CLAVE_SUCURSALES = 'kapi:branches';
export const CLAVE_SUCURSAL = 'kapi:selected_branch';

export interface UsuarioGuardado {
  id: string;
  name: string;
  email: string;
  groups: string[];
  isAdmin: boolean;
}

export interface SucursalGuardada {
  id: string;
  name: string;
  companyName: string;
  logo: string;
  db: string;
  isDefault: boolean;
}

export interface SesionPestana {
  token: string;
  usuario: UsuarioGuardado;
  sucursales: SucursalGuardada[];
  sucursalElegida: string | null;
}

function leer(clave: string): string | null {
  try { return sessionStorage.getItem(clave); } catch { return null; }
}

/** La sesión completa de esta pestaña, o null. Igual que `restoreSession` de lib/auth.tsx: token y usuario, los dos. */
export function leerSesion(): SesionPestana | null {
  const token = leer(CLAVE_TOKEN);
  const crudo = leer(CLAVE_USUARIO);
  if (!token || !crudo) return null;
  let usuario: UsuarioGuardado;
  try {
    const u = JSON.parse(crudo) as Partial<UsuarioGuardado> | null;
    if (!u || typeof u.id !== 'string') return null;
    usuario = { id: u.id, name: u.name ?? u.email ?? '', email: u.email ?? '', groups: Array.isArray(u.groups) ? u.groups : [], isAdmin: Boolean(u.isAdmin) };
  } catch {
    return null;
  }
  let sucursales: SucursalGuardada[] = [];
  try {
    const s = JSON.parse(leer(CLAVE_SUCURSALES) ?? '[]') as unknown;
    if (Array.isArray(s)) sucursales = s.filter((b): b is SucursalGuardada => !!b && typeof (b as SucursalGuardada).id === 'string');
  } catch { /* sin lista */ }
  return { token, usuario, sucursales, sucursalElegida: leer(CLAVE_SUCURSAL) || null };
}

export const haySesion = (): boolean => leerSesion() !== null;

/** Lo mismo que hace lib/auth.tsx:342-350 al recibir `kapi:unauthorized`. */
export function borrarSesion(): void {
  clearAccessToken();
  try {
    for (const k of [CLAVE_TOKEN, CLAVE_USUARIO, CLAVE_SUCURSALES, CLAVE_SUCURSAL]) sessionStorage.removeItem(k);
    localStorage.removeItem(CLAVE_TOKEN);
  } catch { /* almacenamiento no disponible */ }
}

